import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { productSchemaObject } from '../productSchema'
import { validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'

export function ProductAddEdit(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            '& > *': {
                margin: theme.spacing(1),
                width: '25ch',
            },
        },
    }));
    const classes = useStyles();
    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Product")
    const [buttonName, setButtonName] = useState("Save")
    const [isChanged, setIsChanged] = useState(0)
    const [product, setProduct] = useState({
        productCode: '',
        productName: '',
        productDescription: '',
        isActive: true
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const schema = Joi.object(productSchemaObject).options({ allowUnknown: true })


    useEffect(() => {
        if (data && edit) {
            setTitle("Edit Product")
            setProduct(data)
            setButtonName("Update")
        } else {
            setTitle("Add Product")
        }
    }, [])

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [product]);


    function handleChange(e) {
        const target = e.target

        const value = target.name === 'isActive' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, productSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setProduct({
            ...product,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleSave(e) {
        e.preventDefault()

        const errorMessages = validate(schema, product)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return

        if (!edit) {
            const response = await services.saveProduct(product)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        else {
            const response = await services.editData(product)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/products' })
            }, 1500);
        }
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function clearState() {
        setProduct({
            ...product,
            productCode: '',
            productName: '',
            productDescription: '',
            isActive: true
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/products"
                        />

                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">


                                <div className="form-group row">
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Product Code *"

                                            name="productCode"
                                            id="productCode"
                                            value={product.productCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["productCode"] && <span id="errbranchCode" className="text text-danger">{errors["productCode"]}</span>}
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Product Name *"
                                            name="productName"
                                            id="productName"

                                            value={product.productName}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["productName"] && <span id="errbranchCode" className="text text-danger">{errors["productName"]}</span>}
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Product Description *"
                                            name="productDescription"
                                            id="productDescription"
                                            value={product.productDescription}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["productDescription"] && <span id="errbranchCode" className="text text-danger">{errors["productDescription"]}</span>}
                                    </div>
                                </div>

                                <br />
                                <label htmlFor="switch1" >Active</label>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isActive"
                                            switch="none"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleChange(e)}
                                            checked={product.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No">
                                        </label>

                                    </div>
                                </div>




                            </div>

                            <div className="card-footer">
                                <input
                                    disabled={validate(schema, product)}
                                    type="submit"
                                    className="btn btn-primary"
                                    value={buttonName}

                                />
                                <input

                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}